// @flow
export default (theme: Object) => ({
    toolbar: {
        fontFamily: 'Inter',
        fontSize: 16,
        // backgroundColor: theme.palette.primary.main,
        // color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[200],
        paddingTop: 4,
        paddingBottom: 4,
    },
    commentIcon: {
        marginRight: theme.spacing(2),
    },
    comments: {
        borderTop: [[1, 'solid', '#e3e3e3']],
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', { duration: theme.transitions.duration.shortest }),
        marginLeft: 'auto',
        marginRight: -16,
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    gigwalkAvatar: {
        backgroundColor: theme.palette.primary.main,
    },
    commentAvatar: {
        marginBottom: 'auto',
        marginTop: 6,
    },
    commentHeader: {
        fontFamily: ['Inter', 'sans-serif'],
        fontSize: 15,
    },
    commentText: {
        fontFamily: ['Inter', 'sans-serif'],
        fontSize: 16,
    },
    author: {
        marginRight: theme.spacing(1),
        fontWeight: 600,
    },
    date: {
        color: 'rgb(170, 170, 170)',
    },
});
